import AddToCartButton from '@/molecules/ShoppingCard/includes/AddToCartButton'
import { setStagingProduct } from '@/store/slices/cart'
import { showModal } from '@/store/slices/modal'
import Product from '@/ts/Product'

function FansiVideo({ product }: FansiVideoProps) {
  const onClick = () => {
    setStagingProduct(product)
    showModal('cart', 'video')
  }

  return (
    <div>
      {product?.status === 'active' && (
        <AddToCartButton onClick={onClick} text="Zamów fansi Video" />
      )}
    </div>
  )
}

interface FansiVideoProps {
  product: Product
}

export default FansiVideo
